export default {
    REFRESH_TOKEN: `user/refresh-token`,
    SIGN_IN: `user/signin`,
    SIGN_UP: `user/create`,
    FORGOT_PASSWORD: `user/forget-pass/init`,
    UPDATE_PROFILE: `user/update`,
    UPDATE_PHOTO: `user/update/photo`,
    RESET_PASSWORD: `user/reset-pass`,
    VERIFY_EMAIL: `user/verify-email`,
    RESEND_VERIFICATION_MAIL: `user/resend-verify-mail`,
    CHANGE_PASSWORD: `user/change-pass`,
    SEND_MESSAGE: (chatbotId) => `chatbot/chat/${chatbotId}`,
    SEND_MESSAGE_EMBED: (chatbotId, tokenId) => `widgetChat/${chatbotId}/${tokenId}`,

    // Post
    GET_POSTS_LIST: (brandId) => `user/brand/${brandId}/posts`,
    CREATE_POST: 'post/create',
    DELETE_POST: (postId) => `post/${postId}/delete`,
    UPDATE_POST: (postId) => `post/${postId}/update`,

    // Facebook
    FACEBOOK_AUTH: 'auth/facebook',
    FACEBOOK_ACCESS_TOKEN: 'auth/facebook/access_token',

    // linkedin
    LINKEDIN_AUTH: 'auth/linkedin',
    LINKEDIN_ACCESS_TOKEN: 'auth/linkedin/access_token',

    // twitter
    TWITTER_AUTH: 'auth/twitter',
    TWITTER_ACCESS_TOKEN: 'auth/twitter/access_token',

    // connect pages
    CONNECT_PAGES: 'auth/facebook/sync',

    // user brands
    USER_BRANDS: (userId) => `user/${userId}/brands`,

    // remove brand platform
    REMOVE_BRAND_PROFILE : (brandId, platformId)=> `user/remove-integration/${brandId}/${platformId}`,
    REMOVE_BRAND_PROFILE_PAGE : (pageId)=> `user/remove-page/${pageId}`,
};
